import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
}
export function FAQItem({
  question,
  answer
}: FAQItemProps) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-gray-200 last:border-b-0" data-id="element-2">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full py-6 flex items-start justify-between text-left hover:bg-cream-200/50 transition-colors px-4 -mx-4 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500" aria-expanded={isOpen} data-id="element-3">
        <span className="font-heading font-semibold text-lg text-gray-900 pr-8" data-id="element-4">
          {question}
        </span>
        <ChevronDownIcon className={`w-6 h-6 text-teal-500 flex-shrink-0 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-5" />
      </button>
      <div className={`overflow-hidden transition-all duration-300 ${isOpen ? 'max-h-96 pb-6' : 'max-h-0'}`} data-id="element-6">
        <p className="text-gray-700 leading-relaxed px-4" data-id="element-7">{answer}</p>
      </div>
    </div>;
}